import { render, staticRenderFns } from "./CompGuestsNumber.vue?vue&type=template&id=02d00bb2"
import script from "./CompGuestsNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGuestsNumber.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports